import React from 'react';

var _path;

var SvgPackageMajor = function SvgPackageMajor(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", Object.assign({
      viewBox: "0 0 20 20"
    }, props), _path || (_path =
    /*#__PURE__*/
    React.createElement("path", {
      d: "M19 5h-8V2h5.227c.382-.001.736.162.928.429L19 5zM3.773 2H9v3H1l1.845-2.571c.192-.267.546-.43.928-.429zM1 7v10.5A1.5 1.5 0 0 0 2.5 19h15a1.5 1.5 0 0 0 1.5-1.5V7H1zm2 2h6v4H3V9z"
    })))
  );
};

export { SvgPackageMajor as S };